import Zad1Photo from "./photo";

export default function StreetPhotoTestPage() {
    return <>
        <h1>TO JEST TYLKO TEST!</h1>
        <Zad1Photo onComplete={() => {}} />
    </>
}
